import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './account-settings-upgrade-dialog.component.html',
  styleUrls: ['./account-settings-upgrade-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountSettingsUpgradeDialogComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<AccountSettingsUpgradeDialogComponent>) {}

  ngOnInit() {}

  public closeDialog() {
    this.dialogRef.close();
  }
}
